const day = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  timeZone: 'UTC',
})

/** A date the API sent as `2026-10-12`, read as 12 October 2026. */
export function longDate(iso: string): string {
  return day.format(new Date(`${iso}T00:00:00Z`))
}

const gbp = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' })

/** A price in pounds, as the API holds it (major units, two places). */
export function pounds(amount: number): string {
  return gbp.format(amount)
}
